import * as Event from '../tools/Event';
import serialize from 'form-serialize';


export const init = () => {
	const elements = [...document.querySelectorAll('[data-visa-guide]')];

	const init = (element) => {
		const DEFAULT_TREE = {
			'visa-eu': {
				'eu-yes': {
					nextStep: 'visa-step-no-need',
				},
				'eu-no': {
					nextStep: 'visa-step-reason',
					'visa-reason': {
						'exchange-student': {
							nextStep: 'visa-step-duration-1',
							'visa-duration': {
								'up-to-90': {
									nextStep: 'visa-step-short-term',
								},
								'over-90': {
									nextStep: 'visa-step-long-term-studies',
								},
								'more-than-year': {
									nextStep: 'visa-step-long-term-residence-studies',
								},
							},
						},
						'fulldegree-student': {
							nextStep: 'visa-step-duration-2',
							'visa-duration': {
								'up-to-90': {
									nextStep: 'visa-step-short-term',
								},
								'over-90': {
									nextStep: 'visa-step-long-term-studies',
								},
							},
						},
						'researcher': {
							nextStep: 'visa-step-duration-2',
							'visa-duration': {
								'up-to-90': {
									nextStep: 'visa-step-short-term',
								},
								'over-90': {
									nextStep: 'visa-step-long-term-research',
								},
							},
						},
						'others': {
							nextStep: 'visa-step-duration-2',
							'visa-duration': {
								'up-to-90': {
									nextStep: 'visa-step-short-term',
								},
								'over-90': {
									nextStep: 'visa-step-long-term-employment',
								},
							},
						},
					},
				},
			},
		};
		let tree = DEFAULT_TREE;

		const onNext = (event) => {
			event.preventDefault();
			const form = event.target;
			const formData = serialize(form).split('=');
			const key = formData[0];
			const value = formData[1];
			const nextData = tree[key] ? tree[key][value] : false;

			if (!nextData) return;

			const nextStep = nextData.nextStep;

			if (nextStep) {
				const nextStepElement = document.querySelector(`#${nextStep}`);

				if (nextStepElement) {
					const nextStepHtml = nextStepElement.innerHTML;

					tree = {...nextData};
					form.innerHTML = nextStepHtml;
				}
			}
		};

		Event.on(element, 'submit', onNext);
	};


	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/visaGuide.js